import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import Layout from '../components/Layout';
import Container from '../components/Container';
import Meta from '../components/Meta';
import Breadcrumb from '../components/Breadcrumb';

const Contact = () => {
  const { t } = useTranslation('contact');

  return (
    <Layout className="page-privacy-policy">
      <Meta
        title={t('contact:meta.title')}
        description={t('contact:meta.description')}
      />
      <Container narrow>
        <Breadcrumb>
          <Breadcrumb.Item href="/">
            {t('common:nav.index')}
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            {t('common:nav.contact')}
          </Breadcrumb.Item>
        </Breadcrumb>
        <article className="content">
          <h1>
            {t('contact:intro.title')}
          </h1>
          <p>
            {t('contact:intro.text')}
          </p>
          <a href="mailto:contact@pdfedit.pro">
            contact@pdfedit.pro
          </a>
        </article>
      </Container>
    </Layout>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...await serverSideTranslations(locale, [
      'common',
      'contact',
    ]),
  },
});

export default Contact;
